module.exports = __webpack_public_path__ + "static/media/TR.5af758d2.svg";